import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import cssClasses from "./Login.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import strip1 from "../../Assets/Images/Login/strip1.svg";
import strip2 from "../../Assets/Images/Login/strip2.svg";
import strip3 from "../../Assets/Images/Login/strip3.svg";
import strip4 from "../../Assets/Images/Login/strip4.svg";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";

import { loginWithEmailPass, getUser, insertLoginLogs, getTeamHierarchy } from "../../Services/LoginService";
import { errorTost, successTost } from "../../Services/Toast";
import { authSignUp, insertUser } from "../../Services/Users";
import { dismissLoader, presentLoader } from "../../Services/loader";

import logo from '../../Assets/Images/SideMenu/vjLogo.jpg';
import axios from "axios";
import { getAllLeadAllotmentReport, getAllTokenLeadReport } from "../../Services/Lead";
import * as XLSX from 'xlsx';
import actions from "../../Redux Store/actions";
const useStyles = makeStyles((theme) => ({
  title: {
    color: "#1C1C1C",
    fontFamily: "Inter-Medium",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "1rem",
  },
  label: {
    display: "inline-block",
    fontFamily: "Inter-Medium",
    fontWeight: "400",
    fontSize: "1.4rem",
    lineheight: "2rem",
    /* identical to box height, or 143% */

    /* Gray/500 */

    color: "#667085",
    marginRight: "0.4rem",
  },
  signUp: {
    display: "inline-block",
    fontFamily: "Inter-Medium",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineheight: "2rem",
    cursor: "pointer",
    color: "#175CD3",
  },
}));
export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const [loginDetails, setLoginDetails] = useState({
    emailId: "",
    password: "",
  });
  const [team, setTeam] = useState([])
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [helperText, setHelperText] = useState({
    isEmailValid: "",
    isPasswordValid: "",
  });
  function validateLogin() {
    var form = true;
    if (loginDetails.emailId === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isEmailValid = "Please Enter Email Id";
        return { ...preValue };
      });
    }
    if (loginDetails.password === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPasswordValid = "Please Enter Password";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }

  async function login() {
    let flag = validateLogin();
    if (flag.flag && helperText.isEmailValid === '' && helperText.isPasswordValid === '') {
      // console.log('Logged In successfully');
      setIsLoginLoading(true);
      // e.preventDefault()
      loginDetails.emailId = loginDetails.emailId.toLowerCase();
      loginWithEmailPass(loginDetails.emailId, loginDetails.password)
        .then((res) => {
          getUser(loginDetails.emailId).then(async (userRes) => {
            // console.log(userRes)
              // if (userRes && userRes.length > 0) {
              if (userRes && userRes.length > 0 && userRes[0].isActive) {
                let logObj = {
                  userId: userRes[0].userId,
                  action: "login",
                  latitude: '',
                  longitude: '',
                  ipv4: ''
                }
                getTeamHierarchy(userRes[0]).then((resp) => {
                  setIsLoginLoading(false);
                  successTost(res.message);
                  dispatch(action.authLogin({ ...res.user, ...userRes[0] }));
                  navigate('/home');
                })
                axios.get(process.env.REACT_APP_IPIFY_URL).then(async (resp) => {
                  logObj.ipv4 = resp.data
                  const getGeoLocationResponse = await getGeoLocation();
                  if (getGeoLocationResponse.success) {
                    logObj.latitude = getGeoLocationResponse.data.latitude
                    logObj.longitude = getGeoLocationResponse.data.longitude
                  }
                  insertLoginLogs(logObj).then((insertRes) => {
                    // ! no need to check if backend is working
                    // axios.get(`${process.env.REACT_APP_PAYMENT_LINK_URL}payments`).then((resp) => {
                    //   console.log(resp)
                    // })
  
                  }).catch((err) => {
                    setIsLoginLoading(false);
                  })
                }).catch((err) => {
                  // setIsLoginLoading(false);
                  // successTost(res.message);
                  // navigate('/home');
                  // dispatch(action.authLogin({ ...res.user, ...userRes[0] }));
                })
              } else if(userRes && userRes.length > 0 && !userRes[0].isActive) {
                setIsLoginLoading(false);
                errorTost(loginDetails.emailId + ' has been blocked! Please contact your Admin');
              } else {
                setIsLoginLoading(false);
                // console.log(userRes);
                errorTost('Could not find user with email ' + loginDetails.emailId + ' !');
              }
            // } else if(!userRes[0].isActive) {
            //   setIsLoginLoading(false);
            //   errorTost(loginDetails.emailId + ' has been Blocked! please contact your Admin');
            // }
            
          }).catch((err) => {
            setIsLoginLoading(false);
            console.log(err);
            errorTost(err.message);
          })
        }).catch((err) => {
          console.log(err);
          setIsLoginLoading(false);
          errorTost(err.message);
        });
    }
  }
  
  function navigateWithUserAccess(userRes,accessibleTabs,i){
    if(accessibleTabs==='All Allotment'){
      navigate('/home/AllAllotments');
      dispatch(actions.activeMenu('allallotments'));
    }else if(accessibleTabs==='Benefit Plan'){
      navigate('/home/BenefitPlan');
      dispatch(actions.activeMenu('benefitplan'));
    }else if(accessibleTabs==='Partners'){
      navigate('/home/ChannelPartner');
      dispatch(actions.activeMenu('channelpartner'));
    }
    else if(accessibleTabs==='Dashboard'){
      navigate('/home/Dashboard');
      dispatch(actions.activeMenu('dashboard'));
    }
    else if(accessibleTabs==='Event'){
      navigate('/home/Event');
      dispatch(actions.activeMenu('event'));
    }
    else if(accessibleTabs==='FastBooking'){
      navigate('/home/FastBooking');
      dispatch(actions.activeMenu('fastbooking'));
    }
    else if(accessibleTabs==='Hierarchy'){
      navigate('/home/Hierarchy');
      dispatch(actions.activeMenu('hierarchy'));
    }
    else if(accessibleTabs==='Leads'){
      navigate('/home/Leads');
      dispatch(actions.activeMenu('leads'));
    }
    else if(accessibleTabs==='Live Inventory'){
      navigate('/home/LiveInventory');
      dispatch(actions.activeMenu('liveinventory'));
    }
    else if(accessibleTabs==='Payments'){
      navigate('/home/Payments');
      dispatch(actions.activeMenu('payments'));
    }
    else if(accessibleTabs==='Profile'){
      navigate('/home/Profile');
      dispatch(actions.activeMenu('profile'));
    }
    else if(accessibleTabs==='Project'){
      navigate('/home/Projects');
      dispatch(actions.activeMenu('project'));
    }
       else if(accessibleTabs==='Hold'){
      navigate('/home/Hold');
      dispatch(actions.activeMenu('Hold'));
    }
    else if(accessibleTabs==='Queue'){
      navigate('/home/Queue');
      dispatch(actions.activeMenu('queue'));
    }
    else if(accessibleTabs==='Settings'){
      navigate('/home/Settings');
      dispatch(actions.activeMenu('settings'));
    }
    else if(accessibleTabs==='Sustenance'){
      navigate('/home/Sustenance');
      dispatch(actions.activeMenu('sustenance'));
    }
    else if(accessibleTabs==='Token'){
      navigate('/home/Token');
      dispatch(actions.activeMenu('token'));
    }
    else if(accessibleTabs==='Users'){
      navigate('/home/users');
      dispatch(actions.activeMenu('users'));
    }else{
      navigateWithUserAccess(userRes,Object.keys(userRes[0].roleId.accessibleTabs)[i+1],i+1);
    }
  }

  function getGeoLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
      } else {
        resolve({ success: false, message: "Geolocation is not supported by this browser." });
      }

      function geoSuccess(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        resolve({ success: true, data: { latitude, longitude } });
      }
      function geoError() {
        resolve({ success: false, message: "Geocoder failed." });
      }
    })
  }

  // async function createUserToServer() {
  //   try {
  //     presentLoader();
  //     const authSignUpResponse = await authSignUp({email: 'admin@gmail.com', password: 'admin123'});
  //     if (authSignUpResponse.user) {
  //       let postBody = {
  //         userId: authSignUpResponse.user.id,
  //         name: 'Admin',
  //         email: 'admin@gmail.com',
  //         contactNumber: '999999999',
  //         roleId: '5d963b4a-a994-467e-b393-cef94567ef15',
  //         completedTabs: ["Add Details"]
  //       }
  //       const insertUserResponse = await insertUser(postBody);
  //       console.log('insert user data',insertUserResponse);
  //       if (insertUserResponse.data) {
  //         dismissLoader();
  //         navigate(`/home/users/createUser?userId=${insertUserResponse.data.userId}`);
  //         successTost("User details added successfully.");
  //       } else {
  //         console.log("error => ", insertUserResponse);
  //         if (insertUserResponse?.error?.message) {
  //           errorTost(insertUserResponse.error.message);
  //         } else {
  //           errorTost("Something went wrong! Try again");
  //         }
  //         dismissLoader();
  //       }
  //     } else {
  //       console.log("error => ", authSignUpResponse);
  //       if (authSignUpResponse?.error?.message) {
  //         errorTost(authSignUpResponse.error.message);
  //       } else {
  //         errorTost("Something went wrong! Try again");
  //       }
  //       dismissLoader();
  //     }
  //   } catch (error) {
  //     console.log("Error= -> ", error);
  //     if (error?.error?.message) {
  //       errorTost(error?.error?.message);
  //     } else {
  //       errorTost("Something went wrong! Try again");
  //     }
  //     dismissLoader();
  //   }
  // }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.backgroundImage}>
        {/* <img
          src={strip1}
          className={cssClasses.strip1}
          alt="backgroundImage"
        ></img> */}
        <img
          src={strip2}
          className={cssClasses.strip2}
          alt="backgroundImage"
        ></img>

        {/* <img
          src={strip4}
          className={cssClasses.strip4}
          alt="backgroundImage"
        ></img> */}
        <img
          src={strip3}
          className={cssClasses.strip3}
          alt="backgroundImage"
        ></img>

        <div className={cssClasses.registerationBlock}>
          <div><img src={logo} style={{ width: '23rem' }} alt="vj-logo"></img></div>
          <div className={classes.title}>Welcome Back</div>
          <div style={{ textAlign: "left" }}>
            <CustomInput
              label={"Email"}
              mandatory={true}
              value={loginDetails.emailId}
              handleChange={(newValue) => {
                // console.log(newValue);
                const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!newValue.trim()) {
                  helperText.isEmailValid = "Please Enter Email Id";
                } else if (!newValue.match(emailIDCond)) {
                  helperText.isEmailValid =
                    "Please Enter Email in Proper Format";
                } else {
                  helperText.isEmailValid = "";
                }
                // console.log(newValue);
                let pre = Object.assign({}, loginDetails);
                pre.emailId = newValue;
                setLoginDetails({ ...pre });
              }}
              // onKeyPress={(event) => {
              //   console.log(event);
              //   if(helperText.isEmailValid===''&&helperText.isPasswordValid===''){
              //     if (event.key === "Enter") {
              //       login();
              //     }
              //   }
              // }}
              placeholder="Enter your email"
              inputType="label"
              helperText={helperText.isEmailValid}
            />
          </div>
          <div style={{ textAlign: "left" }}>
            <CustomInput
              label={"Password"}
              mandatory={true}
              value={loginDetails.password}
              handleChange={(value) => {
                let errors = helperText;
                if (!value.trim()) {
                  errors.isPasswordValid = "Please Enter Password";
                }
                //  else if (value.search(/[A-Z]/) < 0) {
                //   errors.isPasswordValid =
                //     "Password should contain atleast 1 Uppercase.";
                // }
                else if (value.search(/[a-z]/) < 0) {
                  errors.isPasswordValid =
                    "Password should contain atleast 1 LowerCase.";
                  // } else if (value.search(/[0-9]/) < 0) {
                  //   errors.isPasswordValid =
                  //     "Password should contain atleast 1 number.";
                } else if (value.length < 6) {
                  errors.isPasswordValid =
                    "Password should contain atleast 6 Characters.";
                } else {
                  errors.isPasswordValid = "";
                }
                setHelperText(errors);

                // console.log(value);
                let pre = Object.assign({}, loginDetails);
                pre.password = value;
                setLoginDetails({ ...pre });
              }}
              placeholder="Enter your password"
              inputType="password"
              helperText={helperText.isPasswordValid}
              onKeyPress={(event) => {
                // console.log(event);
                if (helperText.isEmailValid === '' && helperText.isPasswordValid === '') {
                  if (event.key === "Enter") {
                    login();
                  }
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#1570EF",
              }}
              btnName={"Login"}
              clicked={login}
              isLoading={isLoginLoading}
            />
          </div>
          <div style={{ textAlign: 'right' }}>
            <div className={classes.signUp} onClick={() => {
              navigate("/ForgetPassword");
            }}>
              Forgot Password?
            </div>
            <div className={classes.label} style={{ marginLeft: '0.5rem' }}>Reset your password now!</div>
            {/* <div className={classes.label}>Don’t have an account?</div>
            <div className={classes.signUp} onClick={navigateToSignUp}>
              Signup
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
